/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_ByInputs */

const cs_order_by = /** @type {(inputs: Order_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řadit podle`)
};

const en_order_by = /** @type {(inputs: Order_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order by`)
};

/**
* | output |
* | --- |
* | "Order by" |
*
* @param {Order_ByInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_by = /** @type {((inputs?: Order_ByInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_ByInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_by(inputs)
	return cs_order_by(inputs)
});